<template>
  <div class="info-region-container">
    <div class="all-content-container" style="margin: 0 auto; width: 100%; margin-top: 10px">
      <div class="container1">
        <div class="titlemaun" style="">
          <div style="padding: 15px; border: ">
            <h3>农事记录</h3>
          </div>
          <div class="table-title-btn">
            <el-button v-allow="'090302'" type="primary" class="adduser" @click="add">添加</el-button>
            <el-button type="primary" style="margin-left: 10px" @click="handleImport">导入</el-button>
            <el-button type="primary" style="margin-right: 20px" class="button" @click="exoprtExcel">导出</el-button>
            <!-- <el-button type="primary" class="adduser" @click="handleReturn">返回决策模型</el-button> -->
          </div>
        </div>

        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-row>
            <el-form-item label="分组：">
              <el-cascader expand-trigger="hover" v-model="groupIdArr" :options="groupArray" :props="optionProps" @change="groupChange" placeholder="请选择分组" collapse-tags clearable></el-cascader>
            </el-form-item>
            <el-form-item label="作物名称：">
              <el-select v-model="searchForm.cropId" clearable placeholder="请选择">
                <el-option v-for="item in Crops" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="作业人员：">
              <el-select v-model="searchForm.staffId" clearable placeholder="请选择">
                <el-option v-for="item in Staffs" :key="item.id" :label="item.realName" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="农事类型：">
              <el-select v-model="searchForm.workTypeId" clearable placeholder="请选择">
                <el-option v-for="item in options" :key="item.id" :label="item.workType" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="农事内容：">
              <el-input v-model="searchForm.workContent" placeholder="请输入农事内容"></el-input>
            </el-form-item>

            <el-form-item label="时间：">
              <el-date-picker style="width: 80%" v-model="alarmTime_" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" align="right" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" clearable @change="handleSearch"> </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" class="button" @click="handleSearch">查询</el-button>
              <el-button type="button" ass="button" @click="handleRest">重置</el-button>
            </el-form-item>
            <el-form-item>
              <div class="button_li">
                <el-button v-allow="'090302'" type="primary" class="adduser" @click="addType('crop')">作物管理</el-button>
                <el-button v-allow="'090302'" type="primary" class="adduser" @click="addType('cropType')">农事类型管理</el-button>
                <el-button v-allow="'090302'" type="primary" class="adduser" @click="addType('cropDevice')">农事装备管理</el-button>
                <el-button v-allow="'090302'" type="primary" class="adduser" @click="addType('cropPesticide')">农药管理</el-button>
                <el-button v-allow="'090302'" type="primary" class="adduser" @click="addType('cropProductionFertilizer')">肥料管理</el-button>
                <el-button v-allow="'090302'" type="primary" class="adduser" @click="addType('cropStaff')">员工管理</el-button>
              </div>
            </el-form-item>
          </el-row>
        </el-form>
        <!-- <div style="margin-bottom:10px;margin-left:10px">
        </div> -->
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" v-loading="loading" style="width: 100%" :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="序号" width="95">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="开始时间">
              <template slot-scope="scope">
                <p>{{ scope.row.startTime }}</p>
              </template>
            </el-table-column>
            <!-- <el-table-column align="center" label="结束时间">
              <template slot-scope="scope">
                <p>{{ scope.row.endTime }}</p>
              </template>
            </el-table-column> -->
            <el-table-column align="center" label="类型">
              <template slot-scope="scope">
                <p v-if="scope.row.type == 0">农事记录</p>
                <p v-if="scope.row.type == 1">农事计划</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="农事类型">
              <template slot-scope="scope">
                <p>{{ scope.row.workTypeName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="作物名称">
              <template slot-scope="scope">
                <p>{{ scope.row.cropName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="分组名称">
              <template slot-scope="scope">
                <p>{{ scope.row.groupName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="记录人">
              <template slot-scope="scope">
                <p>{{ scope.row.staffName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="农事内容">
              <template slot-scope="scope">
                <p v-if="scope.row.workContent == ''">无</p>
                <p v-else>{{ scope.row.workContent }}</p>
              </template>
            </el-table-column>

            <el-table-column align="center" label="农事照片">
              <template slot-scope="scope">
                <el-image v-if="scope.row.workImage" style="height: 50px" :src="scope.row.workImage != null ? scope.row.workImage.split(',')[0] : ''" :preview-src-list="scope.row.workImage != null ? scope.row.workImage.split(',') : []" fit="contain"> </el-image>
                <p v-else>无</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="状态">
              <template slot-scope="scope">
                <p v-if="scope.row.status == 0">已完成</p>
                <p v-else>未完成</p>
              </template>
            </el-table-column>
            <!-- <el-table-column align="center" label="农事视频">
              <template slot-scope="scope">
                <video :src="scope.row.workVideo" width="120" height="80" controls>
                </video>
              </template>

            </el-table-column> -->

            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button @click="handleClickRole(scope.row.id, 'edit')" type="text" size="small">编辑</el-button>
                <el-button type="text" size="small" @click="delRole(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="searchForm.pageNum" :page-size="searchForm.pageSize" :total="total"></el-pagination>
          </div>
        </div>
      </div>
      <el-dialog :title="dialogTitle" :visible.sync="centerDialogVisible" :before-close="resetForm" width="800px" style="z-index: 10000" center>
        <div style="padding: 5px 50px 30px 10px" class="info-content-container info-content-container-add">
          <el-form :model="dialogformInline" :rules="dialogRules" label-width="120px" ref="REFdialogformInline">
            <el-row>
              <el-col :span="12">
                <el-form-item label="时间：">
                  <el-date-picker v-model="value1" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="分组：" prop="groupId">
                  <el-cascader expand-trigger="hover" v-model="groupIdArr_" :options="groupArray" :props="optionProps" @change="groupChange_" placeholder="请选择分组" collapse-tags clearable></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="作物名称：">
                  <el-select v-model="dialogformInline.cropId" clearable placeholder="请选择">
                    <el-option v-for="item in Crops" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="作业人员：">
                  <el-select v-model="dialogformInline.staffId" clearable placeholder="请选择">
                    <el-option v-for="item in Staffs" :key="item.id" :label="item.realName" :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="农事类型：" prop="workTypeId">
                  <el-select v-model="dialogformInline.workTypeId" clearable placeholder="请选择">
                    <el-option v-for="item in options" :key="item.id" :label="item.workType" :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="农事设备：">
                  <el-select v-model="dialogformInline.deviceId" clearable placeholder="请选择">
                    <el-option v-for="item in Devices" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="农药信息：">
                  <el-select v-model="dialogformInline.pesticideId" clearable placeholder="请选择">
                    <el-option v-for="item in Pesticides" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="农药数量：" prop="pesticideNum">
                  <el-input v-model="dialogformInline.pesticideNum" placeholder="请输入农药数量" maxlength="20"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="肥料信息：">
                  <el-select v-model="dialogformInline.fertilizerId" clearable placeholder="请选择">
                    <el-option v-for="item in Fertilizers" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="肥料数量：" prop="fertilizerNum">
                  <el-input v-model="dialogformInline.fertilizerNum" placeholder="请输入肥料数量" maxlength="20"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 15px">
              <el-col :span="24">
                <el-form-item label="农事内容：" prop="workContent">
                  <el-input style="width: 100%" type="textarea" :autosize="{ minRows: 4, maxRows: 9 }" v-model="dialogformInline.workContent" placeholder="请输入农事内容"></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-form-item label="投入品名称：" prop="workInputName">
                  <el-input v-model="dialogformInline.workInputName" placeholder="请输入投入品名称" maxlength="50"></el-input>
                </el-form-item>
              </el-col> -->
            </el-row>
            <!-- <el-row>
              <el-col :span="12">
                <el-form-item label="作业责任人：" prop="workResponsibleUser">
                  <el-input v-model="dialogformInline.workResponsibleUser" placeholder="请输入作业责任人" maxlength="50"></el-input>
                </el-form-item>
              </el-col>

            </el-row> -->

            <el-row>
              <el-col :span="24">
                <el-form-item label="作业图片：">
                  <UploadImg sirProps="image" :sirUrl="dialogformInline.imagesArr" :limit="6" @upSuccess="upSuccess" :disabled="seeType"></UploadImg>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="24">
                <el-form-item label="作业视频：">
                  <UploadVideo fileUrl="video" :fileUrl="dialogformInline.workVideo" @setVideo="setVideo" width="100" height="100"></UploadVideo>
                </el-form-item>
              </el-col> -->
            </el-row>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="resetForm">取 消</el-button>
          <el-button type="primary" @click="submitForm('REFdialogformInline')">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="导入数据" :visible.sync="importDialog" width="500px" :before-close="handleCloseImport">
        <div class="equipmentcenter-opption-box">
          <el-form ref="importForm" label-width="0px">
            <el-form-item label="" style="width: 100%">
              <el-upload class="upload-demo" :action="$serverUrl + '/pc/productionWork/importProductionWork'" :headers="headers" name="fileName" :before-upload="handleChange" :on-success="handleAvatarSuccess" :limit="1" :file-list="importFileList">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传excel（.xls和.xlsx）文件</div>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import UploadImg from '@/components/upload/MultipleImgUpload.vue'
import UploadVideo from '@/components/upload/UploadVideo.vue'
import moment from 'moment'
export default {
  components: { UploadImg, UploadVideo },

  data() {
    return {
      headers: {
        // 请求头
        AUTHORIZATION: sessionStorage.getItem('TOKEN')
      },
      Fertilizers: [],
      Staffs: [],
      Pesticides: [],
      Devices: [],
      Crops: [],
      value1: '',
      searchForm: {
        // 查询条件字段
        pageNum: 1,
        pageSize: 10,
        groupId: '',
        startTime: '',
        endTime: '',
        cropName: '',
        cropId: '',
        deviceId: '',
        fertilizerId: '',
        pesticideId: '',
        staffId: ''
      },
      dialogformInline: {
        //添加，编辑（参数）
        cropName: '',
        groupId: '',
        workTypeId: '',
        endTime: '',
        startTime: '',
        workArea: '',
        workContent: '',
        workImage: '',
        workResponsibleUser: '',
        workUser: '',
        workVideo: '',
        id: '',
        workInputName: '', // 角色
        groupIdArr: '',
        groupIdArr_: '',
        workVideo: '',
        imagesArr: [],
        cropId: '',
        deviceId: '',
        fertilizerId: '',
        pesticideId: '',
        staffId: '',
        fertilizerNum: '',
        pesticideNum: ''
      },
      dialogRules: {
        // 弹框表单验证
        workTypeId: [{ required: true, message: '请选择农事类型', trigger: 'change' }],
        groupId: [{ required: true, message: '请选择分组', trigger: 'change' }]
        // description: [{ required: true, message: '请输入描述', trigger: 'change' }],
        // description: [{ required: true, message: '请输入描述', trigger: 'change' }],
        // description: [{ required: true, message: '请输入描述', trigger: 'change' }],
        // description: [{ required: true, message: '请输入描述', trigger: 'change' }],
        // description: [{ required: true, message: '请输入描述', trigger: 'change' }],
        // cropName: [{ required: true, message: '请输入角色', trigger: 'change' }]
      },
      groupIdArr: [],
      groupIdArr_: [],
      alarmTime: '',
      alarmTime_: [],
      total: 0, // 总数
      tableData: [],
      importDialog: false,
      loading: false,
      groupArray: [], // 分组数组
      optionProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        multiple: false
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },

      options: [],
      editId: '', //编辑id
      loading: false,
      dialogTitle: '',
      centerDialogVisible: false //添加弹框
    }
  },
  created() {
    // 获取分组列表
    this.getGroupList()
    // 查询
    this.getList()
    this.getProductionWorkTypes()
    this.getProductionFertilizers()
    this.getProductionStaffs()
    this.getProductionPesticides()
    this.getProductionDevices()
  },
  methods: {
    // 导入
    handleImport() {
      this.$confirm('导入数据会在原有数据上进行新增，不会影响已有数据，是否继续导入？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.importDialog = true
        })
        .catch(() => {
          this.$message.info('已取消导入')
        })
    },
    // 关闭导入弹窗
    handleCloseImport() {
      this.importDialog = false
    },
    addType(url) {
      this.$router.push({
        path: `/${url}`
      })
    },
    addType1() {
      this.$router.push({
        path: '/deviceManagement'
      })
    },
    resetForm() {
      this.centerDialogVisible = false
      // this.$refs['REFdialogformInline'].resetFields();
      this.groupIdArr_ = []
      this.dialogformInline = {
        cropName: '',
        groupId: '',
        workTypeId: '',
        endTime: '',
        startTime: '',
        workArea: '',
        workContent: '',
        workImage: '',
        workResponsibleUser: '',
        workUser: '',
        workVideo: '',
        id: '',
        workInputName: '', // 角色
        groupIdArr: '',
        workVideo: '',
        imagesArr: [],
        cropId: '',
        deviceId: '',
        fertilizerId: '',
        pesticideId: '',
        staffId: ''
      }
      this.value1 = ''
    },
    add() {
      this.resetForm()

      this.dialogTitle = '添加'
      this.value1 = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      this.centerDialogVisible = true
    },
    // 上传图片
    setImg(url) {
      this.dialogformInline.workImage = url
    },
    upSuccess(data) {
      this.dialogformInline.imagesArr = data
    },
    // 上传视频
    setVideo(data) {
      this.dialogformInline.workVideo = data
    },
    exoprtExcel() {
      this.$api.growthModel.exportProductionWorkList(this.searchForm).then(res => {
        if (res.code == 200) {
          window.open(res.data)
        }
      })
    },
    // 新增或者编辑
    submitForm(formName) {
      // 提交表单
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log(this.value1)
          this.dialogformInline.startTime = this.value1
          // this.dialogformInline.endTime = this.alarmTime[1]
          this.dialogformInline.workImage = this.dialogformInline.imagesArr.toString()
          this.$api.growthModel.saveProductionWork(this.dialogformInline).then(res => {
            this.alarmTime = []
            if (res.code == 200) {
              this.loading = false
              this.centerDialogVisible = false
              this.$message({ type: 'success', message: res.msg })
              this.getList()
            } else {
              this.loading = false
            }
          })
        } else {
          return false
        }
      })
    },
    handleClickRole(id, type) {
      //编辑

      if (type == 'edit') {
        this.editId = id // 编辑id
        this.dialogTitle = '编辑'
        this.getProductionWork(id)
      }
    },
    //列表数据编辑获取信息
    getProductionWork(id) {
      this.loading = true //加载中
      this.$api.growthModel.getProductionWork({ id: id }).then(res => {
        if (res.code == 200) {
          this.centerDialogVisible = true
          this.getProductionCrops(res.data.groupId)
          this.loading = false
          this.value1 = res.data.startTime
          this.groupIdArr_ = [this.getParentGroupId(res.data.groupId), res.data.groupId]
          res.data.imagesArr = res.data.workImage != undefined ? res.data.workImage.split(',') : []
          this.alarmTime = [res.data.startTime, res.data.endTime]
          this.dialogformInline = res.data
        } else {
          this.loading = false
        }
      })
    },
    // 获取上级分组id
    getParentGroupId(groupId) {
      let parentGroupId = 0
      let children = []
      this.groupArray.map(item => {
        if (item.children) {
          children = item.children
          let isEnd = false
          children.every(function (val2) {
            if (val2.id == groupId) {
              parentGroupId = val2.parentId
              isEnd = true
            }
            return val2.id != groupId
          })
          return !isEnd
        }
      })

      return parentGroupId
    },
    delRole(id) {
      this.$confirm('是否删除？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          console.log(22)
          this.$api.system.delfun(`/pc/productionWork/delProductionWork`, id).then(res => {
            console.log(112)
            if (res.code == 200) {
              this.$message({ type: 'success', message: res.msg })
              this.getList()
            } else {
              this.$message.error(res.msg)
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1
      this.getList()
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        groupId: '',
        startTime: '',
        endTime: ''
      }
      this.groupIdArr = []

      this.alarmTime_ = []
      this.getList()
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage
      this.getList()
    },
    getProductionWorkTypes() {
      this.$api.growthModel.getProductionWorkTypes().then(res => {
        if (res.code == 200) {
          this.options = res.data
        }
      })
    },
    // 作物信息
    getProductionCrops(id) {
      this.$api.growthModel.getProductionCrops({ id }).then(res => {
        if (res.code == 200) {
          this.Crops = res.data
        }
      })
    },
    // 设备
    getProductionDevices() {
      this.$api.growthModel.getProductionDevices().then(res => {
        if (res.code == 200) {
          this.Devices = res.data
        }
      })
    },
    // 农药
    getProductionPesticides() {
      this.$api.growthModel.getProductionPesticides().then(res => {
        if (res.code == 200) {
          this.Pesticides = res.data
        }
      })
    },
    // 员工
    getProductionStaffs() {
      this.$api.growthModel.getProductionStaffs().then(res => {
        if (res.code == 200) {
          this.Staffs = res.data
        }
      })
    },
    // 肥料
    getProductionFertilizers() {
      this.$api.growthModel.getProductionFertilizers().then(res => {
        if (res.code == 200) {
          this.Fertilizers = res.data
        }
      })
    },
    // 分页获取列表
    getList() {
      this.loading = true
      if (this.alarmTime_ && this.alarmTime_.length == 2) {
        this.searchForm.startTime = this.alarmTime_[0]
        this.searchForm.endTime = this.alarmTime_[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
      this.$api.growthModel.getProductionWorkList(this.searchForm).then(res => {
        if (res.code == 200) {
          this.tableData = res.data
          if (this.tableData.length == 0 && this.currentPage > 1) {
            this.currentPage = this.currentPage - 1
            this.getList()
          }
          this.total = res.count
        }
        this.loading = false
      })
    },
    // 获取分组列表
    getGroupList() {
      this.$api.system.getGroupList().then(res => {
        if (res.code == 200) {
          this.groupArray = res.data
        }
      })
    },
    // 大棚下拉切换
    groupChange() {
      // 不是三级分类
      if (!this.groupIdArr || this.groupIdArr.length != 2) {
        this.groupIdArr = []
        this.searchForm.groupId = ''
      } else {
        this.searchForm.groupId = this.groupIdArr[1]
      }
      this.getProductionCrops(this.searchForm.groupId)
      this.getList()
    },
    groupChange_() {
      if (!this.groupIdArr_ || this.groupIdArr_.length != 2) {
        this.groupIdArr_ = []
        this.dialogformInline.groupId = ''
      } else {
        this.dialogformInline.groupId = this.groupIdArr_[1]
      }
      this.getProductionCrops(this.dialogformInline.groupId)
    },
    // 推送模型转名称
    topushModel(pm) {
      return pm == undefined || pm == null ? '' : pm.toString().replace('0', '邮箱发送').replace('1', '短信发送').replace('2', 'APP推送').replace('3', '小程序推送').replace('4', '语音拨号提醒')
    }
  }
}
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 30px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
.cursipon {
  cursor: pointer;
}
.button_li {
  width: 100%;
  margin-left: 30px;
  display: flex;
  justify-content: right;
}
</style>
